const GitIcon = () => {
  return (
    <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white">
      <path
        d="M7.35925 29.8162C8.0326 29.758 8.62638 29.992 9.17385 30.3579C9.78663 30.7675 10.2391 31.3209 10.6132 31.9503C11.1298 32.8207 11.8246 33.4929 12.8208 33.7862C13.911 34.1081 14.9549 33.8991 15.9704 33.4632"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6298 39.66C7.75026 37.3431 1.99902 30.0575 1.99902 21.4286C1.99902 10.9341 10.5055 2.42761 21 2.42761C31.4945 2.42761 40.001 10.9341 40.001 21.4286C40.001 30.0575 34.2496 37.3431 26.37 39.66C24.6672 40.1613 22.8657 40.4296 21 40.4296C19.1343 40.4296 17.3328 40.1613 15.6298 39.66Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6301 39.6601C16.0195 39.2373 16.2464 38.6744 16.25 38.0545V33.3256C16.2464 31.1513 17.1073 30.5777 17.7356 29.6181C7.80647 28.1361 7.49403 19.006 10.9617 14.8994C11.0153 14.8377 11.064 14.7201 11.0413 14.6537C10.5094 13.0458 10.5782 9.50436 11.7955 9.56018C13.4628 9.63737 14.7929 10.5768 16.3402 11.4972C16.4579 11.5661 16.5517 11.5933 16.6882 11.5566C18.1109 11.1706 19.5491 10.9616 21.0003 10.9437C22.4514 10.9616 23.8896 11.1706 25.3122 11.5566C25.4489 11.5933 25.5427 11.5661 25.6603 11.4972C27.2075 10.5768 28.5376 9.63737 30.2049 9.56018C31.4222 9.50436 31.4912 13.0458 30.9592 14.6537C30.9366 14.7201 30.9853 14.8377 31.0387 14.8994C34.5064 19.006 34.194 28.1361 24.2649 29.6181C24.8931 30.5777 25.7541 31.1513 25.7505 33.3256V38.0545C25.7541 38.6744 25.9809 39.2373 26.3703 39.6601"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default GitIcon
